<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="32"
    viewBox="0 0 21 32"
    fill="none"
  >
    <path
      d="M20.6145 19.3516C20.6782 20.0346 20.7115 20.7209 20.7115 21.4061C20.7115 30.0343 15.3361 32.0038 10.7151 32.0038C6.09416 32.0038 0.71875 29.753 0.71875 21.4061C0.71875 20.9958 0.731508 20.5838 0.756328 20.1711L2.92493 21.6168L6.55998 19.5396L10.195 21.6168L13.9599 20.3186L17.0757 22.2659L20.6145 19.3516Z"
      fill="currentColor"
    />
    <path
      d="M0.444937 18.3172L2.90478 19.1717L5.90225 16.2488L9.94224 17.3473L13.2608 15.1458L16.7656 16.2489L19.4612 12.5379C16.7592 5.05908 10.2188 -0.962419 6.01723 0.126828C1.67702 1.25201 -1.09424 10.4679 0.444937 18.3172Z"
      fill="currentColor"
    />
  </svg>
</template>